module.exports = __webpack_public_path__ + "static/img/newFood4.caa1441.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newFood4.png
// module id = ufO3
// module chunks = 2